import { render } from "./ExploreTwo.vue?vue&type=template&id=9b37f45a"
import script from "./ExploreTwo.vue?vue&type=script&lang=js"
export * from "./ExploreTwo.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__